import { useDispatch, useSelector } from "react-redux";
import {
  showCustomLoader,
  hideCustomLoader,
} from "../components/base/Loader/LoaderSlice";

const useCustomLoader = () => {
  const dispatch = useDispatch();

  const customLoading = useSelector((state) => state.loader.customLoading);

  const openCustomLoader = () => dispatch(showCustomLoader());
  const closeCustomLoader = () => dispatch(hideCustomLoader());

  return {
    openCustomLoader,
    closeCustomLoader,
    customLoading,
  };
};

export default useCustomLoader;
